import { render, staticRenderFns } from "./FeaturedPostListing.vue?vue&type=template&id=22c66a6a&scoped=true"
import script from "./FeaturedPostListing.vue?vue&type=script&lang=js"
export * from "./FeaturedPostListing.vue?vue&type=script&lang=js"
import style0 from "./FeaturedPostListing.vue?vue&type=style&index=0&id=22c66a6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c66a6a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedPostListing.vue
// module id = 213
// module chunks = 0